import useQuickReply from './use-quick-reply';

export default { useQuickReply };

export { useQuickReply };
